import Text from 'components/common/Text';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import IdMeImage from 'images/id-me-button.svg';

const IdMeVerify = ({ endpoint, brand }) => {
  const handleIdMeClickWithAnalytics = useAnalyticsCallback(
    null,
    ({ logEvent, events }) => {
      if (brand) {
        logEvent(events.signUp[brand].promo.newSignUpIdmeClicked);
      }
    },
    [brand]
  );

  return (
    <a
      className="mt-4 block h-11 w-40 border-none bg-no-repeat pb-12"
      href={endpoint}
      onClick={handleIdMeClickWithAnalytics}
      style={{ backgroundImage: `url(${IdMeImage})` }}
    >
      <Text htmlElement="span" className="sr-only">
        Verify with ID.me
      </Text>
    </a>
  );
};

IdMeVerify.propTypes = {
  endpoint: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default IdMeVerify;
